import { useFeatureFlagQuery } from "./index";

export type AiInsightsTabsVisibility = {
	reviews: boolean;
	engagement: boolean;
	meetings: boolean;
	surveys: boolean;
	employees: boolean;
};

/**
 * Which AI Insights admin sub-tabs the company can see, and whether the page is reachable at all.
 * The domain sub-tabs belong to the AI package; Employees ships with Coaching, so it is gated on the
 * coaching FF instead. Shared by the admin nav and the page so the two can never disagree.
 */
export const useAiInsightsVisibility = (): { tabs: AiInsightsTabsVisibility; visible: boolean } => {
	const { value: aiEnabled } = useFeatureFlagQuery("ff-is-ai-enabled", false);
	const { value: coachingEnabled } = useFeatureFlagQuery("ff-is-coaching-enabled", false);
	const { value: reviewsFlagEnabled } = useFeatureFlagQuery("ff-is-reviews-enabled", false);
	const { value: engagementSurveyEnabled } = useFeatureFlagQuery("ff-is-engagement-survey-enabled", false);
	const { value: meetingsEnabled } = useFeatureFlagQuery("ff-is-meetings-enabled", false);
	const { value: surveysEnabled } = useFeatureFlagQuery("ff-is-surveys-enabled", false);

	const tabs = {
		reviews: aiEnabled && reviewsFlagEnabled,
		engagement: aiEnabled && engagementSurveyEnabled,
		meetings: aiEnabled && meetingsEnabled,
		surveys: aiEnabled && surveysEnabled,
		employees: coachingEnabled,
	};

	return { tabs, visible: Object.values(tabs).some(Boolean) };
};
